import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { Shared, SocialMediaAccounts } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    url: `${CENTRAL_API_V3}/customers/@customerId/socialmedia/channels/info`,
    query: {} as { accessToken: string; type: Shared.SocialPlatforms },
    response: {} as SocialMediaAccounts.Get.MetaChannelInfo,
  },
};
